// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tc_tcPage__-Jco6 {
  margin: 5vw; /* relative to viewport width */
  font-family: "Times New Roman", Times, serif;
  padding: 1rem; /* optional padding for small screens */
  box-sizing: border-box; /* ensures padding/margin doesn't break layout */
}

.tc_tcPage__-Jco6 h2 {
  text-align: center;
  font-size: 2rem; /* scalable heading */
}

/* Adjust margin and font for smaller screens */
@media (max-width: 768px) {
  .tc_tcPage__-Jco6 {
    margin: 3vw;
    font-size: 0.9rem;
  }

  .tc_tcPage__-Jco6 h2 {
    font-size: 1.5rem;
  }
}

@media (max-width: 480px) {
  .tc_tcPage__-Jco6 {
    margin: 2vw;
    font-size: 0.8rem;
  }

  .tc_tcPage__-Jco6 h2 {
    font-size: 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/TERMS_CONDITIONS/tc.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW,EAAE,+BAA+B;EAC5C,4CAA4C;EAC5C,aAAa,EAAE,uCAAuC;EACtD,sBAAsB,EAAE,gDAAgD;AAC1E;;AAEA;EACE,kBAAkB;EAClB,eAAe,EAAE,qBAAqB;AACxC;;AAEA,+CAA+C;AAC/C;EACE;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".tcPage {\n  margin: 5vw; /* relative to viewport width */\n  font-family: \"Times New Roman\", Times, serif;\n  padding: 1rem; /* optional padding for small screens */\n  box-sizing: border-box; /* ensures padding/margin doesn't break layout */\n}\n\n.tcPage h2 {\n  text-align: center;\n  font-size: 2rem; /* scalable heading */\n}\n\n/* Adjust margin and font for smaller screens */\n@media (max-width: 768px) {\n  .tcPage {\n    margin: 3vw;\n    font-size: 0.9rem;\n  }\n\n  .tcPage h2 {\n    font-size: 1.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .tcPage {\n    margin: 2vw;\n    font-size: 0.8rem;\n  }\n\n  .tcPage h2 {\n    font-size: 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tcPage": `tc_tcPage__-Jco6`
};
export default ___CSS_LOADER_EXPORT___;
